import { Button, Dropdown, Avatar, Popover } from "flowbite-react";
import { useState } from "react";
import { useAuth } from "react-oidc-context";
import { Link } from "react-router-dom";
import { IoMenu } from "react-icons/io5";
import { FaSignOutAlt, FaRegUser } from "react-icons/fa";
import { SearchBar } from "./Search";
import { useNavigate } from "react-router-dom";

export default function Header() {
  const navigate = useNavigate();
  const auth = useAuth();

  const UserState = () => {
    if (auth.isAuthenticated) {
      var initials, i;
      i = auth.user.profile.name.trim().split(" ");
      if (i.length > 1) {
        initials = i[0].charAt(0) + i[i.length - 1].charAt(0);
      } else {
        initials = i[0].charAt(0);
      }
      return (
        <div>
          <Dropdown
            color="gray"
            arrowIcon={false}
            label={
              <Avatar
                size="xs"
                alt="User Settings"
                placeholderInitials={initials.toUpperCase()}
                rounded
                {...(auth.user.profile.picture !== undefined
                  ? { img: `${auth.user.profile.picture}` }
                  : {})}
              />
            }
          >
            <Dropdown.Header>
              <span className="block text-sm">{auth.user.profile.name}</span>
              <span className="block text-sm">{auth.user.profile.email}</span>
            </Dropdown.Header>
            <Dropdown.Item
              icon={FaRegUser}
              onClick={() => void navigate("/profile")}
            >
              Profile
            </Dropdown.Item>
            <Dropdown.Item
              icon={FaSignOutAlt}
              onClick={() => void auth.signoutRedirect()}
            >
              Logout
            </Dropdown.Item>
          </Dropdown>
        </div>
      );
    } else {
      return (
        <div>
          <Button
            color="gray"
            className="mx-auto text-sm"
            onClick={() => void auth.signinRedirect()}
          >
            Login/Signup
          </Button>
        </div>
      );
    }
  };
  const Logo = () => {
    return (
      <Link to="/">
        <img src="/logo.png" alt="NILO" height="50" width="138" />
      </Link>
    );
  };

  const [sbOpen, setSbOpen] = useState(false);
  const LinkList = () => {
    const [popen, setPopen] = useState(false);
    const auth = useAuth();
    if (
      auth.isAuthenticated &&
      !auth.user.profile.realm_access.roles.includes("Sponsors")
    ) {
      return <></>;
    }
    return (
      <>
        <div>
          <Link
            to="/"
            onClick={() => {
              setSbOpen(false);
              setPopen(false);
            }}
          >
            Home
          </Link>
        </div>
        <div>
          <Popover
            open={popen}
            onOpenChange={setPopen}
            content={
              <div className="flex  [&>*]:mx-4 [&>*]:my-2">
                <div>
                  <Link
                    to="/Sport"
                    onClick={() => {
                      setSbOpen(false);
                      setPopen(false);
                    }}
                  >
                    By Sport
                  </Link>
                </div>
                <div>
                  <Link
                    to="/Conf"
                    onClick={() => {
                      setSbOpen(false);
                      setPopen(false);
                    }}
                  >
                    By Conference
                  </Link>
                </div>
                <div>
                  <Link
                    to="/Division"
                    onClick={() => {
                      setSbOpen(false);
                      setPopen(false);
                    }}
                  >
                    By Division
                  </Link>
                </div>
              </div>
            }
            trigger="click"
          >
            <p className="cursor-pointer">Teams</p>
          </Popover>
        </div>
      </>
    );
  };
  const Menu = () => {
    return (
      <>
        <div className="my-auto hidden lg:inline-block">
          <div className="flex justify-start [&>*]:mx-4 ">
            <LinkList />
          </div>
        </div>
        <div className="my-auto lg:hidden block">
          <Button color="gray" onClick={() => setSbOpen(!sbOpen)}>
            <IoMenu />
          </Button>
          <div
            className={`${
              sbOpen ? "block" : "hidden"
            } absolute z-40 duration-1000 left-0 top-85 px-auto py-auto`}
          >
            <div className="bg-white bg-opacity-90 [&>*]:mx-3 [&>*]:my-3">
              <LinkList />
            </div>
          </div>
        </div>{" "}
      </>
    );
  };

  // Check if Logged in User is an Athlete
  const isAthlete = () => {
    return (
      auth.isAuthenticated &&
      auth.user.profile.realm_access.roles.includes("Athletes")
    );
  };

  return (
    <div className="sm:fixed absolute top-0 inset-x-0 w-full bg-white z-10">
      <div className="grid grid-cols-3">
        {/* Left Side */}
        <div className="justify-around flex flex-row items-center content-center">
          {isAthlete() ? <></> : <Menu />}
          <div className="inline-block sm:hidden px-4 ">
            {isAthlete() ? <></> : <SearchBar />}
          </div>
        </div>

        {/* Center Logo */}
        <div className="justify-center m-auto">
          <Logo />
        </div>

        <div className="justify-between flex flex-row items-center content-center m-auto">
          <div className="hidden sm:inline-block px-4">
            {isAthlete() ? <></> : <SearchBar />}
          </div>
          <UserState />
        </div>
      </div>
    </div>
  );
}
